export default __webpack_public_path__ + "images/abcbd7e85d5743386b2b517d94ad3583.png";